import { BetResponseCode } from '@pascal/pascal-core';
import { prepareChunkArray } from './prepareChunkArray';
import { hiLoBetTypes, mainBetTypes, moreBetTypes } from '../enums/betTypes';
import { cardTypeParser } from './cardTypeParser';

export const moreData = (allBetTypes) => {
  const filteredMoreBetData = allBetTypes
    .filter((betType) => moreBetTypes[betType.marketType])
    .map((betType) => ({ betType: moreBetTypes[betType.marketType], ...betType }));

  return prepareChunkArray(filteredMoreBetData, 3).reverse();
};

export const hiLoData = (allBetTypes) => {
  return allBetTypes
    .filter((betType) => hiLoBetTypes[betType.marketType])
    .map((betType) => {
      return {
        ...betType,
        betType: hiLoBetTypes[betType.marketType].split('_')[0],
      };
    });
};

export const mainHiLoParser = (number, hiLoBetData) => {
  const hiOrLoMarket = [];

  const openedHiLoCardTypeId = cardTypeParser(number);
  if (openedHiLoCardTypeId) {
    hiLoBetData.forEach((betTypes) => {
      if (betTypes.number === openedHiLoCardTypeId) {
        hiOrLoMarket.push(betTypes);
      }
    });
  }
  return hiOrLoMarket;
};

const sortingArr = [58, 59, 61, 64, 63, 62, 60];

export const mainData = (allBetTypes) => {
  return allBetTypes
    .filter((betType) => mainBetTypes[betType.marketType])
    .sort((a, b) => sortingArr.indexOf(a.marketType) - sortingArr.indexOf(b.marketType))
    .map((betType) => {
      const { type, styleId } = mainBetTypes[betType.marketType];
      return {
        betType: type,
        styleId,
        ...betType,
      };
    });
};

export const checkDoBetModel = (limits, userBalance, amount) => {
  let generatedBetResponseCode;
  if (Number(amount) < limits.minBet) {
    generatedBetResponseCode = BetResponseCode.InValidMinBet;
  } else if (Number(amount) > limits.maxBet) {
    generatedBetResponseCode = BetResponseCode.InValidMaxBet;
  }

  return generatedBetResponseCode;
};

export const betAmountValidator = (betAmount, limits) => {
  let validatedBetAmount = null;
  let errorMessageCode = null;
  const { maxBet, minBet } = limits;

  switch (true) {
    case !maxBet || (betAmount > maxBet && maxBet < minBet): {
      errorMessageCode = BetResponseCode.InsufficientFunds;
      validatedBetAmount = minBet;
      break;
    }
    case Number.isNaN(betAmount) || betAmount <= minBet: {
      if (betAmount < minBet) {
        errorMessageCode = BetResponseCode.InValidMinBet;
      }
      validatedBetAmount = minBet;
      break;
    }
    case betAmount > maxBet: {
      errorMessageCode = BetResponseCode.InValidMaxBet;

      validatedBetAmount = maxBet;
      break;
    }
    default:
      validatedBetAmount = betAmount;
  }

  return { validatedBetAmount, errorMessageCode };
};
